<div class="row g-3" [formGroup]="shiftForm">
  <div class="col-lg-4">
    <div class="card mb-3">
      <div class="card-body p-3">
        <div class="row g-3">
          <div class="col-12">
            <h5 (click)="router.navigate(['/services', translateField.transform(assignment, 'slug')])" class="cursor-pointer">
              <fa-icon [icon]="fa.faChevronCircleLeft"
                style="font-size: 1.7rem; position: relative; top: 3px; margin-inline-end: 0.3rem;"
                class="cursor-pointer"></fa-icon>
              {{ assignment | translateField: 'name' }}
            </h5>
            <div *ngFor="let product of orderProducts; let i = index"
              class="col-12 mb-3 d-flex align-items-center">
              <img [alt]="product.product | translateField: 'name'" [src]="product.product.picture" class="me-2"
                style="width: 4rem; height: 4rem; border-radius: 50%; object-fit: cover;">
              <div class="flex-grow-1">
                <div>{{ product.number | number: '1.0-2' }} x <strong>{{ product.product | translateField:
                    'name'
                    }}</strong> (<span style="text-transform: lowercase;">{{ product.product.unit | i18nSelect:
                    productUnits
                    }}</span>)</div>
                <div *ngIf="product.notes" class="text-muted">{{ product.notes }}</div>
              </div>
              <div class="ms-2 text-nowrap">
                <button (click)="editProduct(i)" class="btn btn-primary me-1">
                  <fa-icon [icon]="fa.faEdit" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                </button>
                <button (click)="deleteProduct(i)" class="btn btn-danger">
                  <fa-icon [icon]="fa.faTrash" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                </button>
              </div>
            </div>
            <div clas="col-12 mb-3" *ngIf="orderProducts.length == 0">
              <div class="input-group w-100">
                <span class="input-group-text w-100" i18n>
                  Your order is empty. Go back to order.
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 mt-0">
            <h5 i18n>Location</h5>
            <button (click)="setLocation()" type="button" class="btn btn-primary w-100">
              {{ locationName }}
            </button>
          </div>
          <div class="col-12">
            <h5 i18n>Start date</h5>
            <div class="input-group rounded">
              <input class="form-control" ngbDatepicker [markDisabled]="invalidStartDate" [minDate]="minDate"
                #date="ngbDatepicker" formControlName="date" (dateSelect)="setDate($event)" [readonly]="true"
                (click)="date.toggle()">
              <button class="btn btn-primary" (click)="date.toggle()" type="button"><fa-icon
                  [icon]="fa.faCalendar" style="color: #fff; top: -1px;"></fa-icon></button>
            </div>
          </div>
          <div *ngIf="currentUser.discounts.length > 0 || !isSignedIn" class="col-12">
            <h5 i18n>Discount</h5>
            <select (change)="listEmployees()" class="form-control" formControlName="discount_id">
              <option *ngIf="!isSignedIn" [ngValue]="null" i18n>Sign in to see discounts</option>
              <ng-container *ngIf="isSignedIn">
                <option [ngValue]="null" i18n>No discount</option>
                <option *ngFor="let discount of currentUser.discounts" [ngValue]="discount.id">
                  {{ discount.type | i18nSelect: discountTypes }} {{ discount.discount_percent | number: '1.0-2'
                  }}%
                </option>
              </ng-container>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-8 mt-0 mt-lg-3">
    <div class="card mb-3">
      <div class="card-body p-3">
        <h5 i18n>Partner</h5>
        <div class="row">
          <div class="col-4">
            <label class="form-label" i18n>Language</label>
            <select #languageSelect class="form-control" (change)="setLanguage($event)">
              <option value="" i18n>All languages</option>
              <option *ngFor="let lang of organizationLanguages" [value]="lang" [selected]="lang == localeLang">
                {{ languageFlag(lang) }}
                {{ lang | i18nSelect: languagesLocalized }}
                ({{ lang | i18nSelect: languages }})
              </option>
            </select>
          </div>
          <div class="col-4">
            <label class="form-label" i18n>Filter by</label>
            <select class="form-control" (change)="setBadge($event)">
              <option value="" i18n>Show all</option>
              <option *ngFor="let badge of badges | localeSort: 'name'" [value]="badge.id">
                {{ badge.icon }}
                {{ badge | translateField: 'name' }}
              </option>
            </select>
          </div>
          <div class="col-4">
            <label class="form-label" i18n>Sort by</label>
            <select class="form-control" (change)="setSort($event)">
              <option value="rating" i18n>⭐ Best Rated</option>
              <option value="price_asc" i18n>💰 Lowest Price</option>
              <option value="price_desc" i18n>💸 Highest Price</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!shiftForm.valid" class="card mb-3">
      <div class="card-header text-center rounded" i18n>Select location and date first.</div>
    </div>

    <div *ngIf="firstSearchDone && sortedEmployees.length == 0" class="card mb-3">
      <div class="card-header text-center rounded"><ng-container i18n>No available partners found
          for</ng-container> {{ this.shiftForm.controls.date.value | date: 'shortDate' }} . <ng-container i18n>Try
          different date or language.</ng-container></div>
    </div>

    <ng-container *ngFor="let employee of sortedEmployees; trackBy: trackByEmployee">
      <div class="card mb-3">
        <div class="card-header rounded p-3">
          <div class="row">
            <div class="col-auto">
              <img [alt]="'Picture of ' + employee.first_name" [src]="employee.picture"
                style="border-radius: 50%; width: 5rem;" class="">
              <div style="font-size: 1.3rem;" class="text-center">{{ employee.price | currency:
                organization.currency }}</div>
              <div *ngIf="employee.discount" class="text-danger text-center">
                {{ employee.discount * -1| currency: organization.currency }}
              </div>
            </div>
            <div class="col">
              <h5 class="mb-0">{{ employee.first_name }}</h5>
              <div>{{ employee | translateField: 'description' }}</div>

              <span *ngIf="!employee.rating" i18n>Just started, no ratings yet</span>
              <span *ngIf="employee.rating" class="mx-2">
                <span *ngIf="employee.rating >= 0.5">
                  <fa-icon [icon]="fa.faStar" style="color: #ffd700;"></fa-icon>
                </span>
                <span *ngIf="employee.rating >= 1.5">
                  <fa-icon [icon]="fa.faStar" style="color: #ffd700;"></fa-icon>
                </span>
                <span *ngIf="employee.rating >= 2.5">
                  <fa-icon [icon]="fa.faStar" style="color: #ffd700;"></fa-icon>
                </span>
                <span *ngIf="employee.rating >= 3.5">
                  <fa-icon [icon]="fa.faStar" style="color: #ffd700;"></fa-icon>
                </span>
                <span *ngIf="employee.rating >= 4.5">
                  <fa-icon [icon]="fa.faStar" style="color: #ffd700;"></fa-icon>
                </span>
                &nbsp;{{ employee.rating }}&nbsp;

                <span *ngIf="employee.ratings > 0" (click)="feedback(employee)" type="button"
                  class="badge rounded-pill bg-primary cursor-pointer">
                  {{ employee.ratings }}&nbsp;<ng-container i18n>ratings</ng-container>
                </span>
              </span>
              <div>
                <span *ngFor="let skill of employee.skills" class="badge rounded-pill bg-secondary me-1">
                  <ng-container *ngIf="skill.language_code">{{ languageFlag(skill.language_code)
                    }}</ng-container>
                  {{ skill | translateField: 'name' }}</span>
                <span *ngFor="let badge of employee.badges" class="badge rounded-pill bg-secondary me-1">
                  {{ badge.icon }} {{ badge | translateField: 'name' }}
                </span>
              </div>
            </div>
          </div>
          <div class="row mt-0 g-3" [formGroup]="employeeForms[employee.id]">
            <div *ngFor="let available of employee.availability; let i = index;" class="col-12">
              <div formArrayName="start_times" class="input-group">
                <div class="input-group-text" style="width: 9.5rem;">{{ available.date | date: 'EE' }} {{ available.date | date: 'shortDate' }}</div>
                <select [formControlName]="i" class="form-control">
                  <option *ngFor="let available of available.times" [ngValue]="available[0]">{{
                    available[0] }} - {{ available[1] }}</option>
                </select>
              </div>
            </div>
            <div class="col-12">
              <button class="btn btn-primary w-100" (click)="selectEmployee(employee.id)">Select</button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>